var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuPrintsIcon = function SvgMenuPrintsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108770",
    d: "M0 0v21.743h21.743V0Zm19.931 19.931H1.812V1.812h18.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108771",
    d: "M5.21 10.468c2.5-1.308 3.221.679 4.933 1.452 2.57.3.728-6.816 3.682-6.79 3.481 1.3 4.944 11.483 4.944 11.483h-15.8s.488-5.231 2.238-6.146Z"
  })));
};
export default SvgMenuPrintsIcon;